import { ReactNode } from 'react'

import { ConfigMarket } from '@App/redux/interfaces'

import classes from './styles.module.scss'
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'

export const LimitOrderBlockView = ({
  current_market,
  formBtn,
  isLogin,
  children,
}: {
  formBtn?: ReactNode
  current_market: ConfigMarket
  isLogin?: boolean
  children?: ReactNode
}) => {
  return (
    <>
      <div className={classes.block}>
        {isLogin && (
          <div className={classes.topSection}>
            <div className={classes.currencyPair}>
              <MarketIcon symbol={current_market.symbol}/> {current_market.title}
            </div>
            {children}
          </div>
        )}

        {formBtn}
      </div>
    </>
  )
}
